import tw from 'twin.macro';

import { ApiKeysTable } from '@account_module/components/ApiKeysTable';
import { ApiKeysBilling } from '@account_module/components/ApiKeysBilling';
import { Header } from '@components/Header';

const Wrapper = tw.div`w-full h-screen flex flex-col overflow-hidden`;
const Content = tw.div`w-full h-full p-[24px] flex gap-[16px] overflow-scroll`;

export const SelfServeApiPage = () => {
  return (
    <Wrapper>
      <Header />

      <Content>
        <ApiKeysBilling />
        <ApiKeysTable />
      </Content>
    </Wrapper>
  );
};
